var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"light",class:{on : _vm.value, off : !_vm.value},style:({ width : _vm.size, height : _vm.size, borderRadius : _vm.size})})
}
var staticRenderFns = []

export { render, staticRenderFns }